/*
 * Fetches a catalog type from API and saves it in the vuex store
 * (note: you must first add the catalog type to the
 * vuex catalog module state)
 *
 * Usage: catalogService.fetch('warehouse')
 *          .then(=> ...)
 *
 * To receive a particular item:
 *
 * catalogService.fetch('warehouse', 27)
 *
 * catalogService.fetch('warehouse', {noStore: true})
 */

import Vue from "vue";
import WarehouseTransformer from "../../../transformers/catalog/warehouse/warehouse";

export default (catalog, opts = {}) => {
  let url = `/purchase/${catalog}/`;

  if (typeof opts !== "object") {
    opts = {
      id: opts,
    };
  }

  if (opts.id) {
    url += `${opts.id}/`;
  }

  if (opts.extraId) {
    url += `${opts.extraId}/`;
  }

  const fetchDetail = !opts.collection && !!opts.id;

  return Vue.$http.get(url, opts.config).then((response) => {
    const transformer = opts.transformer || WarehouseTransformer[catalog];
    let data = response.data;
    if (!Array.isArray(data)) {
      data = [data];
    }
    const datas = WarehouseTransformer.fetchCollection(data);

    if (transformer && transformer.fetch) {
      data = fetchDetail
        ? transformer.fetch(datas)
        : transformer.fetchCollection(datas);
    }
    return datas;
  });
};



// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchWarehouse.js